<template lang="html">
  <router-link :to="{ name: 'PatrimonialLandscape' }" class="anonymous-short">
		<template v-if="isAnonymous">
			Accès anonyme - Accéder à votre profil et renseignez votre Paysage Patrimonial
		</template>
		<template v-else>
			Accéder à votre profil et renseignez votre Paysage Patrimonial
		</template>
  </router-link>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	name: 'NoEstateShort',
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/NoEstateShort.vue